<ng-container *ngIf="value">
  <mat-select [(ngModel)]="value.type">
    <mat-option class="bus-seat-search-option" value="username">
      搜账号
    </mat-option>
    <mat-option class="bus-seat-search-option" value="bus_id">
      搜车号
    </mat-option>
  </mat-select>

  <input type="text" [(ngModel)]="value.input" placeholder="请输入关键词" />
  <button matRipple (click)="onChange()">搜索</button>
</ng-container>
